"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var space_1 = require("./space");
/**
 * Convert a `string` to pascal case.
 */


function pascalCaseIt(str) {
  return space_1.spaceCaseIt(str).replace(/(?:^|\s)(\w)/g, function (matches, letter) {
    return letter.toUpperCase();
  });
}

exports.pascalCaseIt = pascalCaseIt;